import React from 'react';

import { Table, } from 'react-bootstrap';

import './styles.css'
import CorpoMon from '../../components/Mon';


function ServerMonitoringTable({ data, }) {
  return (
    <Table
      responsive
      striped
      bordered
      hover
      size="sm"
    >
      <thead>
        <tr>
          <th>Empresa</th>
          <th>Servidor</th>
          <th>Squid</th>
          <th>Firewall</th>
          <th>Samba</th>
          <th>HTTP</th>
          <th>VPN</th>
          <th>Máquina</th>
          <th>Rede</th>
          <th>DHCP</th>
          <th>DNS</th>
          <th>MYSQL</th>
          <th>Backup</th>
          <th>Disco</th>
          <th>Memória</th>
          <th>BKP</th>
          <th>LAST UPDATE</th>
          <th>IP</th>
          <th>FW-Acesso</th>
          <th>IP-Acesso</th>
        </tr>
      </thead>

      {
        data
          .sort((a, b) => a.fantasia.localeCompare(b.fantasia))
          .map((item) => {
            return (
              <CorpoMon
                key={item.id}
                data={item}
              />
            );
          })
      }
    </Table>
  );
}

export default ServerMonitoringTable;
